import Quill from 'quill';

// Registrar o Blot customizado apenas uma vez
let mentionBlotRegistered = false;

export function registerMentionBlot() {
  if (mentionBlotRegistered) return;
  
  const Inline = Quill.import('blots/inline') as any;

  class MentionBlot extends Inline {
    static blotName = 'mention';
    static tagName = 'span';
    static className = 'mention-inline';

    static create(data: { userId: number; userName: string }) {
      const node = super.create();
      node.setAttribute('data-user-id', data.userId.toString());
      node.setAttribute('contenteditable', 'false');
      node.style.cssText = 'display: inline-block; padding: 2px 8px; margin: 0 2px; background: #10B981; color: white; border-radius: 12px; font-size: 0.875rem; font-weight: 500; cursor: default;';
      // Limpar qualquer conteúdo existente antes de adicionar o texto
      node.innerHTML = '';
      node.textContent = `@${data.userName}`;
      return node;
    }

    static formats(node: HTMLElement) {
      const userId = node.getAttribute('data-user-id');
      const userName = node.textContent?.replace('@', '') || '';
      if (userId) {
        return {
          userId: parseInt(userId),
          userName: userName
        };
      }
      return null;
    }

    format(name: string, value: any) {
      if (name === 'mention' && value) {
        const node = (this as any).domNode;
        node.setAttribute('data-user-id', value.userId.toString());
        // Limpar qualquer conteúdo existente antes de adicionar o texto
        node.innerHTML = '';
        node.textContent = `@${value.userName}`;
      } else {
        super.format(name, value);
      }
    }
  }

  Quill.register(MentionBlot as any);
  mentionBlotRegistered = true;
}
